import { dirname, extname } from 'path';
import { existsSync, promises } from 'fs';
import { pipe, when, identity } from '@fluss/core';
import { resolve } from './promise.js';

/** Checks if a path points to a directory. */
const isDirectory = (path) => extname(path) === '';

const mkdir = pipe(
	when(isDirectory)(identity, dirname),
	when((path) => existsSync(path))(resolve, (directory) =>
		promises.mkdir(directory, { recursive: true }),
	),
);

export { isDirectory, mkdir };
